import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { Router } from "@angular/router";

import { tap, map, catchError } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";
import { ClientForm } from "../../interfaces/client-form.interface";
import { MasterclusterForm } from "app/interfaces/mastercluster-form.interface";

const clientsUrlApi = environment.clientsUrlApi;
const blockUnblockUrlApi = environment.blockUnblockClientById;
const masterClustersUrlApi = environment.masterClustersUrlApi;

@Injectable()
export class MasterClusterService {
  public user: UserForm;
  public master: MasterclusterForm;

  constructor(private router: Router, private http: HttpClient) {}

  getMasterClusters() {
    return this.http
      .request("GET", `${masterClustersUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getMasterClusterById(id: number) {
    return this.http
      .request("GET", `${masterClustersUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  updateMasterClusterById(id: number, userModel: UserForm) {
    console.log(id);
    console.log(userModel);
    delete userModel.active;
    const body = userModel;
    return this.http
      .request("PUT", `${masterClustersUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  createMasterCluster(masterModel: MasterclusterForm) {
    const body = masterModel;
    return this.http
      .request("POST", `${masterClustersUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }
}
